import * as types from './mutation-types'

// accion para cambiar data modalidad
export const setTorneoSimulator = ({ commit }, data) => {
  commit(types.SET_DATA_TORNEO_SIMULATOR, data)
}
